const MONTH = [
  "فروردین",
  "اردیبهشت",
  "خرداد",
  "تیر",
  "مرداد",
  "شهریور",
  "مهر",
  "آبان",
  "آذر",
  "دی",
  "بهمن",
  "اسفند",
];
function convertDate(date) {
  date = date.split("/");
  return `${parseInt(date[2])} ${MONTH[parseInt(date[1])]} ${date[0]}`;
}

export { convertDate };
